import { CheckboxField, Id } from "@dgs/core";
import { ReactNode } from "react";
import { DataFieldIndexResource } from "../../types/dataField";
import {
	ContactAttributeRequest,
	IContactAttributeBaseHandler,
	IContactAttributeHandler,
	IContactAttributeListHandler,
} from "../IContactAttributeHandler";

export function createCheckboxDataFieldContactAttributeBaseHandler(
	id: Id,
	dataField: DataFieldIndexResource,
): IContactAttributeBaseHandler {
	return {
		type: "CHECKBOX_DATA_FIELD",
		id,
		getLabel: () => dataField.label,
	};
}

export function createCheckboxDataFieldContactAttributeProfileHandler(
	id: Id,
	value: boolean | null,
	dataField: DataFieldIndexResource,
): IContactAttributeHandler<boolean, boolean | null> {
	const baseHandler = createCheckboxDataFieldContactAttributeBaseHandler(id, dataField);
	return {
		...baseHandler,
		value,
		validate() {
			return null;
		},
		renderValue(): ReactNode {
			return this.value ? dataField.label : "";
		},
		renderFormField(t, prefix): ReactNode {
			return <CheckboxField name={`${prefix ? `${prefix}.` : ""}${id}.value`} label={baseHandler.getLabel(t)} />;
		},
		toRequestValue(): ContactAttributeRequest<boolean> {
			return { id, value: this.value ?? false };
		},
	};
}

export function createCheckboxDataFieldContactAttributeListHandler(
	id: Id,
	dataField: DataFieldIndexResource,
): IContactAttributeListHandler {
	const baseHandler = createCheckboxDataFieldContactAttributeBaseHandler(id, dataField);
	return {
		...baseHandler,
		getColumnSize: () => "max-content",
	};
}
